/**
 * Normalize pathname for route checks (trailing slash, etc.).
 * `/reset-password/` → `/reset-password` so public-route sets match.
 */
export function normalizeAppPath(pathname) {
  const p = (pathname || "/").trim() || "/";
  if (p === "/") return "/";
  return p.replace(/\/+$/, "") || "/";
}
